define('collections/Podio.Collections.LinkedAccounts',['require','underscore','lib/backbone/Backbone.PodioCollection','lib/Podio.Routes','models/Podio.Models.LinkedAccount'],function(require) {

  var _ = require('underscore');
  var PodioCollection = require('lib/backbone/Backbone.PodioCollection');
  var routes = require('lib/Podio.Routes');

  return PodioCollection.extend({
    configure: function() {
      this.model = require('models/Podio.Models.LinkedAccount');
    },

    initialize: function(models, options) {
      options = options || {};
      _.bindAll(this, 'getConnectedByCapability');

      this.url = routes.account_linked_account_index_path( options.type || '' );
    },

    getConnectedByCapability: function(capability, options) {

      options = _.extend(options || {}, {
        url: routes.all_linked_account_index_path( { capability : capability }),
        reset: true
      });

      return this.fetch(options);
    },

    getByProvider: function(providerName) {
      return this.filter(function(item) {
        return item.get('provider') === providerName;
      });
    },

    getByAccountId: function(accountId) {
      return this.find(function(item) {
        return item.get('linked_account_id') === accountId;
      });
    },

    getUniqueProviders: function() {
      var result = {};
      this.each(function(account) {
        result[account.get('provider')] = account;
      });
      return _.values(result);
    }

  });

});

